import React from 'react';
import Card from 'react-bootstrap/Card'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'

function Blog() {
    return (
        <div>
            <h1 id="blog" >Blog</h1>
            <p>My blog is hosted on <a className="blog-link-body" href='https://medium.com/@villekuosmanen' >Medium</a>. These days I mostly write technical content on robotics and Physical AI, usually concerning the problems I've solved in my day-to-day job.</p>
            <Container className="blog-container" >
                <Row>
                    <Col>
                        <h2>Robotics</h2>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} sm={6}>
                        <a href="https://villekuosmanen.medium.com/a-manifesto-for-open-source-physical-ai-94b0cb38f5d8" className="blog-link"
                        >
                            <Card className="blog-card">
                                <Card.Img variant="top" src="https://miro.medium.com/v2/resize:fit:1400/format:webp/1*SEib4EKdIssZulYUeikcCQ.jpeg" className='blog-image' />
                                <Card.Body >
                                    <Card.Title>A Manifesto for Open-Source Physical AI</Card.Title>
                                    <Card.Text className="blog-description" >
                                    How to build the open-source intelligence powering millions of robots
                                    </Card.Text>
                                    <Card.Text>
                                        <small className="text-muted">5 min read (2025)</small>
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                        </a>
                    </Col>
                    <Col xs={12} sm={6}>
                        <a href="https://villekuosmanen.medium.com/does-learning-from-experience-benefit-small-ai-robotics-models-3de024f930e0" className="blog-link"
                        >
                            <Card className="blog-card">
                                <Card.Img variant="top" src="https://miro.medium.com/v2/resize:fit:1400/format:webp/1*dLde8xagq05pDOsqVd4WPQ.png" className='blog-image' />
                                <Card.Body >
                                    <Card.Title>Does learning from experience benefit small AI robotics models?</Card.Title>
                                    <Card.Text className="blog-description" >
                                        Replicating the RL loop behind Physical Intelligence’s Pi*0.6 foundation model without VLAs or diffusion
                                    </Card.Text>
                                    <Card.Text>
                                        <small className="text-muted">6 min read (2025)</small>
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                        </a>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} sm={6}>
                        <a href="https://villekuosmanen.medium.com/building-a-simple-out-of-distribution-detector-for-physical-ai-models-using-lerobot-bfa02b4a3876" className="blog-link"
                        >
                            <Card className="blog-card">
                                <Card.Img variant="top" src="https://miro.medium.com/v2/resize:fit:1400/format:webp/1*UZUyFjumYD0nTZMGpjy-LQ.png" className='blog-image' />
                                <Card.Body >
                                    <Card.Title>Building a simple out-of-distribution detector for Physical AI models using LeRobot</Card.Title>
                                    <Card.Text className="blog-description" >
                                        In order to solve problems in our robots, we first have to detect them.
                                    </Card.Text>
                                    <Card.Text>
                                        <small className="text-muted">5 min read (2025)</small>
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                        </a>
                    </Col>
                    <Col xs={12} sm={6}>
                        <a href="https://villekuosmanen.medium.com/sharing-gpus-in-ai-robotics-with-cuda-streams-2c56b2d5988b" className="blog-link"
                        >
                            <Card className="blog-card">
                                <Card.Img variant="top" src="https://miro.medium.com/v2/resize:fit:1400/format:webp/1*mtiJWrSpji-og01-_a1-Gw.png" className='blog-image' />
                                <Card.Body >
                                    <Card.Title>Sharing GPUs in AI Robotics with CUDA Streams</Card.Title>
                                    <Card.Text className="blog-description" >
                                        The challenges of maintaining a control frequency in AI robotics when sharing GPUs with other AI models
                                    </Card.Text>
                                    <Card.Text>
                                        <small className="text-muted">8 min read (2025)</small>
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                        </a>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h2>Everything else</h2>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} sm={6}>
                        <a href="https://villekuosmanen.medium.com/aldix-and-the-book-of-life-5da3f0001b6c" className="blog-link"
                        >
                            <Card className="blog-card">
                                <Card.Img variant="top" src="https://miro.medium.com/v2/1*ohJI8TuASEtKkTSE8kyQlg.png" className='blog-image' />
                                <Card.Body >
                                    <Card.Title>Aldix and the Book of Life</Card.Title>
                                    <Card.Text className="blog-description" >
                                        A fable on the dangers of measures becoming targets
                                    </Card.Text>
                                    <Card.Text>
                                        <small className="text-muted">6 min read (2023)</small>
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                        </a>
                    </Col>
                    <Col xs={12} sm={6}>
                        <a href="https://medium.com/age-of-awareness/professors-as-creators-how-the-creator-economy-could-transform-education-99f6bef678f8" className="blog-link"
                        >
                            <Card className="blog-card">
                                <Card.Img variant="top" src="https://miro.medium.com/max/1200/0*KtJ-niNBwyn3k8wO" className='blog-image' />
                                <Card.Body >
                                    <Card.Title>Professors as Creators — how the Creator Economy could transform education</Card.Title>
                                    <Card.Text className="blog-description" >
                                        When choosing a university to attend, which factors do prospective students look for the most?
                                    </Card.Text>
                                    <Card.Text>
                                        <small className="text-muted">4 min read (2022)</small>
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                        </a>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Blog;
